// extracted by mini-css-extract-plugin
export default {"yellowTag":"Tag_yellowTag__63k-h","redTag":"Tag_redTag__z5JI7","blueTag":"Tag_blueTag__PyRYx","purpleTag":"Tag_purpleTag__luMGO","likeAnimation":"Tag_likeAnimation__oNWpP"};